import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import cleanupAnnotations from './helpers/cleanup-annotations';
import Ace from './ace';
import { EDITOR_HEIGHT } from './constants';
const defaultOptions = {};

const CodeEditor = ({
  options = defaultOptions,
  defaultValue = '',
  value = '',
  onChange = Function.prototype,
  onFocus = Function.prototype,
  onBlur = Function.prototype,
  onPaste = Function.prototype,
  onValidate = Function.prototype,
  onAfterEditorConfigured = Function.prototype,

  disabled = false,
  invalid = false,
  height = EDITOR_HEIGHT.min,
}) => {
  const editor = useRef(null);
  const editorNodeRef = useRef(null);
  const silentMode = useRef(null);

  useEffect(() => {
    const editorInstance = Ace.edit(editorNodeRef.current);

    editorInstance.session.setMode(`ace/mode/html`);
    editorInstance.setTheme(`ace/theme/chrome`);
    editorInstance.setOptions(options);
    editorInstance.setValue(value || defaultValue, 1);

    editorInstance.on('change', () => {
      if (!silentMode.current) {
        const editorValue = editorInstance.getValue();
        if (!editorValue) {
          editorInstance.getSession().setAnnotations([]);
        }
        onChange(editorValue);
      }
    });

    editorInstance.on('focus', onFocus);
    editorInstance.on('blur', onBlur);
    editorInstance.on('paste', onPaste);

    editorInstance.getSession().on('changeAnnotation', () => {
      const { session } = editorInstance;
      const editorAnnotations = editorInstance.getSession().getAnnotations();
      const annotations = cleanupAnnotations(editorAnnotations);

      if (editorAnnotations.length !== annotations.length) {
        session.setAnnotations(annotations);
      }

      onValidate({ annotations, value: editorInstance.getValue(), session });
    });

    editor.current = editorInstance;
    onAfterEditorConfigured(editorInstance);

    return () => {
      editor.current.destroy();
      editor.current = null;
    };
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, [height]);

  useEffect(() => {
    if (value && editor.current.getValue() !== value) {
      const selection = editor.current.session.selection.toJSON();

      silentMode.current = true;
      silentMode.current = true;
      editor.current.setValue(value, 1);
      editor.current.session.selection.fromJSON(selection);
      silentMode.current = false;
    }
  }, [value]);

  const classes = classNames('ws-ui-code-editor', `ws-ui-code-editor--height-${height}`, {
    'ws-ui-code-editor--disabled': disabled,
    'ws-ui-code-editor--error': invalid,
  });

  return (
    <div className={classes}>
      <div ref={editorNodeRef} translate="no" />
    </div>
  );
};

export default CodeEditor;
